import { z } from 'zod';

import {
  IN_APP_SUPPORT_CATEGORY,
  IN_APP_SUPPORT_CATEGORY_VALUES,
  MIN_SUPPORT_MESSAGE_HINT,
  MIN_SUPPORT_MESSAGE_LENGTH,
  type InAppSupportCategoryValue,
} from '~/constants/in-app-support';

export type { InAppSupportCategoryValue };

export function inAppSupportCategoryLabel(category: InAppSupportCategoryValue): string {
  switch (category) {
    case IN_APP_SUPPORT_CATEGORY.TECHNICAL:
      return 'Technical';
    case IN_APP_SUPPORT_CATEGORY.BILLING:
      return 'Billing';
    case IN_APP_SUPPORT_CATEGORY.INQUIRIES:
      return 'Inquiries';
    default:
      return 'General question';
  }
}

export const InAppSupportFormSchema = z.object({
  category: z.enum([
    IN_APP_SUPPORT_CATEGORY.TECHNICAL,
    IN_APP_SUPPORT_CATEGORY.BILLING,
    IN_APP_SUPPORT_CATEGORY.GENERAL,
    IN_APP_SUPPORT_CATEGORY.INQUIRIES,
  ]),
  message: z
    .string()
    .min(MIN_SUPPORT_MESSAGE_LENGTH, MIN_SUPPORT_MESSAGE_HINT)
    .max(5000, 'Message cannot exceed 5000 characters'),
});

export type InAppSupportFormData = z.infer<typeof InAppSupportFormSchema>;

export { IN_APP_SUPPORT_CATEGORY_VALUES };
